import React, { useState } from "react";

function GeneralCalculator() {
  const [currentInput, setCurrentInput] = useState("0");
  const [operator, setOperator] = useState(null);
  const [previousInput, setPreviousInput] = useState(null);
  const [waitingForNewInput, setWaitingForNewInput] = useState(false);

  const updateDisplay = (value) => {
    setCurrentInput(value);
  };

  const handleNumberClick = (number) => {
    if (waitingForNewInput) {
      setCurrentInput(number);
      setWaitingForNewInput(false);
    } else {
      setCurrentInput(currentInput === "0" ? number : currentInput + number);
    }
  };

  const handleDecimalClick = () => {
    if (waitingForNewInput) {
      setCurrentInput("0.");
      setWaitingForNewInput(false);
    } else if (!currentInput.includes(".")) {
      setCurrentInput(currentInput + ".");
    }
  };

  const performCalculation = () => {
    const num1 = parseFloat(previousInput);
    const num2 = parseFloat(currentInput);

    if (isNaN(num1) || isNaN(num2) || !operator) {
      return currentInput;
    }

    let result;
    switch (operator) {
      case "+":
        result = num1 + num2;
        break;
      case "-":
        result = num1 - num2;
        break;
      case "*":
        result = num1 * num2;
        break;
      case "/":
        if (num2 === 0) {
          return "Error: Div by 0";
        }
        result = num1 / num2;
        break;
      default:
        return currentInput;
    }
    return parseFloat(result.toFixed(10)).toString();
  };

  const handleOperatorClick = (nextOperator) => {
    if (previousInput === null) {
      setPreviousInput(currentInput);
    } else if (!waitingForNewInput) {
      const result = performCalculation();
      setCurrentInput(result);
      setPreviousInput(result);
    }
    setOperator(nextOperator);
    setWaitingForNewInput(true);
  };

  const handleEqualsClick = () => {
    if (operator === null) return;
    if (waitingForNewInput && previousInput !== null) {
      setCurrentInput(performCalculation());
    } else {
      setCurrentInput(performCalculation());
    }
    setPreviousInput(null);
    setOperator(null);
    setWaitingForNewInput(true);
  };

  const handleClear = () => {
    setCurrentInput("0");
    setOperator(null);
    setPreviousInput(null);
    setWaitingForNewInput(false);
  };

  const handleDelete = () => {
    const newInput = currentInput.slice(0, -1);
    setCurrentInput(newInput === "" ? "0" : newInput);
  };

  const handleButtonClick = (key) => {
    if (!isNaN(key)) {
      handleNumberClick(key);
    } else if (key === ".") {
      handleDecimalClick();
    } else if (key === "C") {
      handleClear();
    } else if (key === "DEL") {
      handleDelete();
    } else if (key === "=") {
      handleEqualsClick();
    } else if (["+", "-", "*", "/"].includes(key)) {
      handleOperatorClick(key);
    }
  };

  return (
    <div className="fade-in">
      <div className="display">{currentInput}</div>
      <div className="button-grid">
        <button
          className="calc-button clear-button"
          onClick={() => handleButtonClick("C")}
        >
          C
        </button>
        <button
          className="calc-button del-button"
          onClick={() => handleButtonClick("DEL")}
        >
          DEL
        </button>
        <button
          className="calc-button operator-button"
          onClick={() => handleButtonClick("/")}
        >
          ÷
        </button>
        <button
          className="calc-button operator-button"
          onClick={() => handleButtonClick("*")}
        >
          ×
        </button>

        <button className="calc-button" onClick={() => handleButtonClick("7")}>
          7
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("8")}>
          8
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("9")}>
          9
        </button>
        <button
          className="calc-button operator-button"
          onClick={() => handleButtonClick("-")}
        >
          −
        </button>

        <button className="calc-button" onClick={() => handleButtonClick("4")}>
          4
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("5")}>
          5
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("6")}>
          6
        </button>
        <button
          className="calc-button operator-button"
          onClick={() => handleButtonClick("+")}
        >
          +
        </button>

        <button className="calc-button" onClick={() => handleButtonClick("1")}>
          1
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("2")}>
          2
        </button>
        <button className="calc-button" onClick={() => handleButtonClick("3")}>
          3
        </button>
        <button
          className="calc-button equals-button"
          onClick={() => handleButtonClick("=")}
        >
          =
        </button>

        <button
          className="calc-button span-2"
          onClick={() => handleButtonClick("0")}
        >
          0
        </button>
        <button className="calc-button" onClick={() => handleButtonClick(".")}>
          .
        </button>
      </div>
    </div>
  );
}

export default GeneralCalculator;
